<template lang="pug">
    .wrapper
        .row
            .col-12.col-sm-12.col-md-12
                h3.label(v-if="context == 'esreps'") ¿Ya estás registrado en ESREPS?
                h3.label(v-if="context == 'colreps'") ¿Ya estás registrado en COLREPS?
                h3.label(v-if="context == 'mexreps'") ¿Ya estás registrado en MEXREPS?
            .col-12.col-sm-12.col-md-12
                button Renovar
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AlreadyRegistered',
    computed: mapState([
        "context",
    ]),
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";
@import "./../../variables_mexreps";

.wrapper {
    display: none;
    margin: $gutter $gutter*2;
    border: 4px solid $color-primary;
    border-style: dotted;
    padding: 36px;

    @include breakpoint($breakpoint-mobile) {
        padding: 24px;
    }
}

.label {
    font-weight: 700;
    font-size: 1.4em;
    margin-bottom: 32px;
    width: 100%;
    text-align: center;
}

button {
    margin: 0 auto;
    display: block;
    padding: 25px 90px;
    text-transform: uppercase;
    border-radius: 8px;
    border: 2px solid $color-primary;
    background-color: #ededed;
    color: $color-black ;
    cursor: pointer;
    font-size: 2em;
    font-weight: 700;

    @include breakpoint($breakpoint-mobile) {
        padding: 12px 32px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/register/AlreadyRegistered.vue